import { gql } from "apollo-boost";

export const RESPONSE_TIMELINE_BY_COUNTRY = gql`
  query GetResponseTimelineByCountry($country: String!) {
    responsesChangeTimelineByCountry(country: $country) {
      isoCode
      name
      data {
        date
        policyType
        policyValue
        notes
      }
    }
  }
`;

export const RESPONSE_TIME_SERIES_BY_COUNTRY = gql`
  query GetResponseTimeSeriesByCountry($country: String!) {
    responsesTimeSeriesByCountry(country: $country) {
      isoCode
      name
      data {
        date
        stringencyIndexForDisplay
        governmentResponseIndexForDisplay
        containmentHealthIndexForDisplay
        economicSupportIndexForDisplay
      }
    }
  }
`;
